import { toastMsg } from "./swal";

export const generateYouTubeEmbedUrlId = (url) => {
    let regex = /[?&]v=([^#&?]*).*/;
    let match = url.match(regex);
    if (!match) {
        regex = /youtu\.be\/([^#&?]*).*/;
        match = url.match(regex);
    }
    if (match && match[1]) {
        const videoId = match[1];
        return videoId;
    } else {
        return null;
    }
};

export const getEmploymentType = (type, t) => {
    let employment_type = "";
    switch (type) {
        case "full_time":
            employment_type = t("employmentTypes.full_time");
            break;
        case "part_time":
            employment_type = t("employmentTypes.part_time");
            break;
        case "internship":
            employment_type = t("employmentTypes.internship");
            break;
        case "contract":
            employment_type = t("employmentTypes.contract");
            break;
        case "freelance":
            employment_type = t("employmentTypes.freelance");
            break;
        case "self_employed":
            employment_type = t("employmentTypes.self_employed");
            break;
        case "volunteer":
            employment_type = t("employmentTypes.volunteer");
            break;
        default:
            employment_type = "";
            break;
    }
    return employment_type;
};

export const handleCopyToClipboard = async (
    textForCopy,
    successText,
    errorText
) => {
    try {
        if (textForCopy) {
            await navigator.clipboard.writeText(textForCopy);
            toastMsg(successText || "Successfully copied !", "#12db63", "#ffffff");
        }
    } catch (err) {
        console.error("Error on copying", err);
        toastMsg(errorText || "Error on copy !", "#ed4611", "#000000");
    }
};

export const getSiteName = (url) => {
    try {
        const normalizedUrl = url.startsWith("http") ? url : `http://${url}`;
        const domain = new URL(normalizedUrl).hostname;
        const siteName = domain.replace("www.", "").split(".")[0];
        return siteName.charAt(0).toUpperCase() + siteName.slice(1).toLowerCase();
    } catch (err) {
        
    }
};

export const URL_REGEX = /^(https?:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/.*)?$/;

export const isValidUrl = (url) => {
    const urlRegex =
        /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+\.[a-zA-Z]{2,}(\/[^\s]*)?$/;
    return urlRegex.test(url);
};

export const formatDateDDMMYYYY = (startDate, startTime) => {
  if (!startDate) return "";
  let dateFormatted = startDate;
  if (startDate.includes("-")) {
    const parts = startDate.split("-");
    if (parts.length === 3) {
      dateFormatted = `${parts[2]}.${parts[1]}.${parts[0]}`;
    }
  }
  const timeFormatted = startTime ? startTime.slice(0, 5) : "";
  return timeFormatted ? `${dateFormatted} ${timeFormatted}` : dateFormatted;
};

export const getInitials = (name) => {
  if (!name) return "?";
  const parts = name.trim().split(" ");
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase();
  }
  return name.slice(0, 2).toUpperCase();
};

export const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    const date = new Date(dateStr);
    return date.toLocaleDateString("az-AZ", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

export const formatDateTime = (dateStr) => {
  if (!dateStr) return "-";
  try {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${day}.${month}.${year} ${hours}:${minutes}`;
  } catch {
    return dateStr;
  }
};

export const clearStorageExceptEventTokens = () => {
  const eventAccess = localStorage.getItem("event_admin_access");
  const eventRefresh = localStorage.getItem("event_admin_refresh");
  localStorage.clear();
  if (eventAccess) localStorage.setItem("event_admin_access", eventAccess);
  if (eventRefresh) localStorage.setItem("event_admin_refresh", eventRefresh);
};
